import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { CrudFilters, CrudSort, MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class PaymentAPIClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/payment');
  }

  async addPayment(
    _sorters: Array<CrudSort>,
    _filters: CrudFilters,
    payload: any,
    _query: any,
    _headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    const url = this.baseURL + '/order/' + meta?.salesChannelOrderId + '/transaction/add/bulk';
    const response = await axiosInstance.post(`${url}`, payload);
    return this.transformNode(response.data?.data);
  }

  async getPayoutDetails(
    _sorters: Array<CrudSort>,
    _filters: CrudFilters,
    _payload: any,
    _query: any,
    _headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    const url = GATEWAY_API_URL + '/payout/' + meta?.payoutTxnId;
    const response = await axiosInstance.get(`${url}`);
    return this.transformNode(response.data?.data);
  }

  async updatePayoutStatus(
    _sorters: Array<CrudSort>,
    _filters: CrudFilters,
    payload: any,
    _query: any,
    _headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    const url = GATEWAY_API_URL + '/payout/' + meta?.payoutTxnId;
    const response = await axiosInstance.put(`${url}`, payload);
    return this.transformNode(response.data?.data);
  }

  async collectPendingPayment(salesChannelOrderId: string, payload: any): Promise<any> {
    const url = `${this.baseURL}/order/${salesChannelOrderId}/transaction/add`;
    const response = await axiosInstance.post(url, payload);
    return this.transformNode(response.data?.data);
  }

  async getPostOrderPaymentOptions(
    orderId: string,
    packageIds?: Array<number | string>,
  ): Promise<any> {
    const queryParams = new URLSearchParams();
    packageIds?.forEach(packageId => {
      if (packageId !== undefined && packageId !== null) {
        queryParams.append('packageIds', String(packageId));
      }
    });
    const queryString = queryParams.toString();
    const url = `${this.baseURL}/order/${orderId}/options${queryString ? `?${queryString}` : ''}`;
    const response = await axiosInstance.get(url);
    return this.transformNode(response.data?.data);
  }

  async getTransactionById(
    salesChannelOrderId: string,
    transactionId: string | number,
  ): Promise<any> {
    const url = `${this.baseURL}/order/${salesChannelOrderId}/transaction/${transactionId}`;
    const response = await axiosInstance.get(url);
    return this.transformNode(response.data?.data);
  }

  async cancelOrderTransaction(
    salesChannelOrderId: string,
    transactionId: string | number,
  ): Promise<any> {
    const url = `${this.baseURL}/order/${salesChannelOrderId}/transaction/${transactionId}`;
    const response = await axiosInstance.delete(url);
    return this.transformNode(response.data?.data);
  }

  async resendOrderTransactionWhatsapp(
    salesChannelOrderId: string,
    transactionId: string | number,
  ): Promise<any> {
    const url = `${this.baseURL}/order/${salesChannelOrderId}/transaction/${transactionId}/whatsapp/resend`;
    const response = await axiosInstance.post(url);
    return this.transformNode(response.data?.data);
  }

  async settleDeliveredRiderLateCapture(
    salesChannelOrderId: string,
    transactionId: string | number,
    remarks?: string,
  ): Promise<any> {
    const url = `${this.baseURL}/order/${salesChannelOrderId}/transaction/${transactionId}/rider-late-capture/settle-delivered`;
    const response = await axiosInstance.post(url, {
      confirmedNoCashCollected: true,
      remarks: remarks?.trim() || undefined,
    });
    return this.transformNode(response.data?.data);
  }
}

export default PaymentAPIClient;
